// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"wqa-z","beautyGrouping":"xqa-z","beautySwatches":"yqa-z","swatches":"zqa-z"};